import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { ApplicationSheetIllustration, InsertFamilyIllustration, TurretInterfaceIllustration } from '../illustrations/TechnicalIllustrations';
const steps = [{
  step: 'Match the holder',
  copy: 'Choose the 1-inch SALXR 16-3D or 3/4-inch SALXR 12-3B system based on the machine and turret.',
  Illustration: TurretInterfaceIllustration
}, {
  step: 'Choose the insert family',
  copy: 'Use MG12 roughing inserts for material removal, -30R chipbreakers when tighter chip control is the priority, or DR80 configurations for the published titanium starting range.',
  Illustration: InsertFamilyIllustration
}, {
  step: 'Share the application',
  copy: 'Provide the work material, machine model and horsepower, workholding, holder size, target depth of cut and feed, and expected quantity.',
  Illustration: ApplicationSheetIllustration
}];
export function ToolSelection() {
  return <section aria-labelledby="tool-selection-heading" className="w-full border-t border-rule bg-white" data-id="element-374" data-mp="3mfay82oef0pv">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-375" data-mp="3dgplio5lyfx0">
        <SectionHeading id="tool-selection-heading" eyebrow="SELECT THE SYSTEM" heading="Three decisions before the first cut" data-id="element-376" data-mp="3demk77z090cz" />

        <div className="relative mt-12" data-id="element-377" data-mp="a08qapmi23gf">
          {/* Desktop: horizontal copper progression rail, visible only in the
              gutters because the cards carry a solid background. */}
          <div aria-hidden="true" className="pointer-events-none absolute left-0 right-0 top-[64px] hidden lg:block" data-id="element-378" data-mp="rkm878zpkg">
            <div className="h-px w-full bg-copper/50" data-id="element-379" data-mp="2krs5ysss6x7y" />
            <span className="absolute left-1/3 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 bg-copper" data-id="element-380" data-mp="2kq79uyqtj67z" />
            <span className="absolute left-2/3 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 bg-copper" data-id="element-381" data-mp="2pos9avy8xlvd" />
          </div>

          <ol className="relative flex flex-col gap-0 lg:grid lg:grid-cols-3 lg:gap-5" data-id="element-382" data-mp="21nf5q9zy33ew">
            {steps.map((item, i) => {
            const {
              Illustration
            } = item;
            const isLast = i === steps.length - 1;
            return <li key={item.step} className="relative flex gap-4 lg:block" data-id="element-383" data-mp="1rwu9uubnoczo" data-mpi={i}>
                  {/* Tablet / mobile: left copper rail in its own column */}
                  <div aria-hidden="true" className="relative flex w-6 shrink-0 justify-center lg:hidden" data-id="element-384" data-mp="1hyo9wi9etgxg">
                    <span className={`absolute left-1/2 w-px -translate-x-1/2 bg-copper/50 ${isLast ? 'top-0 h-[28px]' : 'bottom-0 top-0'}`} data-id="element-385" data-mp="1dzoz4h0zypy3" />
                    <span className="absolute top-[22px] left-1/2 h-1.5 w-1.5 -translate-x-1/2 bg-copper" data-id="element-386" data-mp="33bzfo7732rni" />
                  </div>

                  <article className={`flex min-w-0 flex-1 flex-col border border-rule bg-white p-6 lg:mb-0 lg:h-full lg:p-7 ${isLast ? 'mb-0' : 'mb-5'}`} data-id="element-387" data-mp="3av8pu2neyudm">
                    <div className="flex items-start justify-between gap-5" data-id="element-388" data-mp="3ko7flnuncqyt">
                      <span className="rp-tabular font-display text-[42px] font-medium leading-none text-navy/15 lg:text-[52px]" data-id="element-389" data-mp="3pk4stlam5h7d">
                        {`0${i + 1}`}
                      </span>
                      <div className="rp-blueprint h-[88px] w-[88px] shrink-0 overflow-hidden border border-rule" data-id="element-390" data-mp="2wwisqn0lgup9">
                        <Illustration data-id="element-391" data-mp="31xpzqjuwxpuv" />
                      </div>
                    </div>
                    <h3 className="mt-6 font-display text-[20px] font-medium leading-snug text-navy" data-id="element-392" data-mp="35uudi8es4y9s">
                      {item.step}
                    </h3>
                    <p className="mt-3 text-[15px] leading-[1.65] text-graphite/80" data-id="element-393" data-mp="l5ol9peo8p1g">
                      {item.copy}
                    </p>
                  </article>
                </li>;
          })}
          </ol>
        </div>

        <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="tool-selection" className="mt-10 inline-flex min-h-[52px] w-full items-center justify-center gap-2 bg-navy px-7 text-[14.5px] font-semibold text-white transition-colors duration-150 ease-precise hover:bg-copper sm:w-auto" data-id="element-394" data-mp="esu2rvzs0rh7">
          Request Product Guidance
          <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-395" data-mp="1ce88er3d4ylz" />
        </Link>
      </div>
    </section>;
}